/**
 * Desktop only (750px and wider): the sections under the buy buttons (reviews, videos, comparison table, FAQ,
 * signup) are moved out of the narrow details column to a full-width row under the photos and details.
 * On phones nothing moves, so the order there stays as it is. Re-runs after the colour switcher swaps the page.
 */

const DESKTOP = window.matchMedia('(min-width: 750px)');
const HOLDER_CLASS = 'pdp-below-product';

function place() {
  const loved = document.querySelector('.loved-by');
  const product = document.querySelector('.product-information');
  const grid = document.querySelector('.product-information__grid');
  if (!(loved instanceof HTMLElement) || !(product instanceof HTMLElement) || !(grid instanceof HTMLElement)) return;

  let holder = product.querySelector(`:scope > .${HOLDER_CLASS}`);

  if (DESKTOP.matches) {
    if (!(holder instanceof HTMLElement)) {
      holder = document.createElement('div');
      holder.className = HOLDER_CLASS;
      grid.after(holder);
    }
    if (loved.parentElement !== holder) holder.append(loved);
  } else if (holder instanceof HTMLElement) {
    // Back to where the section was rendered: the end of the buy buttons.
    const home = document.querySelector('.product-form-buttons');
    if (home) home.append(loved);
    holder.remove();
  }
}

function init() {
  place();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

DESKTOP.addEventListener('change', place);
document.addEventListener('shade-switcher:updated', place);
